// src/components/LanguageSwitcher.jsx
import React from "react";
import styled from "styled-components";
import { useLang } from "../context/LanguageContext";

/**
 * Three codes in a segmented pill. Deliberately not a dropdown: with only
 * three options a dropdown hides the choice behind a click, and visitors
 * who don't read the current language can't find it.
 */
export default function LanguageSwitcher({ className, $dark = false }) {
  const { lang, setLang, languages, t } = useLang();

  return (
    <Wrap
      className={className}
      $dark={$dark}
      role="group"
      aria-label={t("nav.language")}
    >
      {languages.map((l) => (
        <Option
          key={l.code}
          type="button"
          $active={l.code === lang}
          $dark={$dark}
          onClick={() => setLang(l.code)}
          aria-pressed={l.code === lang}
          title={l.name}
        >
          {l.label}
        </Option>
      ))}
    </Wrap>
  );
}

const Wrap = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 2px;
  padding: 3px;
  border-radius: ${({ theme }) => theme.radius.pill};
  background: ${({ $dark, theme }) =>
    $dark ? "rgba(255,255,255,0.08)" : theme.color.bgSoft};
`;

const Option = styled.button`
  min-width: 34px;
  height: 28px;
  padding: 0 9px;
  border-radius: ${({ theme }) => theme.radius.pill};
  font-size: 0.7rem;
  font-weight: ${({ theme }) => theme.weight.semi};
  letter-spacing: 0.06em;
  transition:
    background 0.24s ${({ theme }) => theme.ease.out},
    color 0.24s;

  color: ${({ $active, $dark, theme }) => {
    if ($active) return $dark ? theme.color.ink : "#fff";
    return $dark ? "rgba(255,255,255,0.6)" : theme.color.muted;
  }};

  background: ${({ $active, $dark, theme }) => {
    if (!$active) return "transparent";
    return $dark ? "#fff" : theme.color.ink;
  }};

  &:hover {
    color: ${({ $active, $dark, theme }) => {
      if ($active) return $dark ? theme.color.ink : "#fff";
      return $dark ? "#fff" : theme.color.ink;
    }};
  }
`;
